import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const CancelReason = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setloading(true)
        ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments/cancel/reasons`, readItems: { searchTerm: ' ' } })
            .then((result) => {
                console.log('>>>>', result.data)
                setcontent(result.data)
                setloading(false)
            })
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.shipment_cancellation_reason_id
            temp.text = object.reason
            temp.value = object.shipment_cancellation_reason_id
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            search
            clearable
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            error={props.error}
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default CancelReason